/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Prefixes_BlurbInputs */

const en_settings_prefixes_blurb = /** @type {(inputs: Settings_Prefixes_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One per line. Only events whose title starts with a prefix become lessons; the prefix is stripped and the rest is matched to a student by name. Leave empty to sync every event.`)
};

const he_settings_prefixes_blurb = /** @type {(inputs: Settings_Prefixes_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אחת בכל שורה. רק אירועים שכותרתם מתחילה בקידומת הופכים לשיעורים; הקידומת מוסרת והשאר מותאם לתלמיד לפי שם. השאר ריק כדי לסנכרן כל אירוע.`)
};

/**
* | output |
* | --- |
* | "One per line. Only events whose title starts with a prefix become lessons; the prefix is stripped and the rest is matched to a student by name. Leave empty t..." |
*
* @param {Settings_Prefixes_BlurbInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_prefixes_blurb = /** @type {((inputs?: Settings_Prefixes_BlurbInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prefixes_BlurbInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_prefixes_blurb(inputs)
	return he_settings_prefixes_blurb(inputs)
});